import React, { createContext, useState } from "react";
import { SuperOrder } from "@beeldit/ecommerce/super-orders/models/SuperOrder";

interface DetailsActionContextType {
  backendFormErrors: any;
  setBackendFormErrors: (backendFormErrors: any) => void;
  element: SuperOrder;
  setElement: (element: any) => void;
  loading: boolean;
  setLoading: (loading: boolean) => void;
}

export const DetailsActionContext = createContext<DetailsActionContextType>({
  backendFormErrors: {},
  setBackendFormErrors: () => {},
  element: new SuperOrder(),
  setElement: () => {},
  loading: false,
  setLoading: () => {},
});

interface DetailsActionProviderProps {
  children: React.ReactNode;
}

export const DetailsActionProvider: React.FC<DetailsActionProviderProps> = ({
  children,
}) => {
  const [backendFormErrors, setBackendFormErrors] = useState(null);
  const [element, setElement] = useState<SuperOrder>(new SuperOrder());
  const [loading, setLoading] = useState(false);

  const value = {
    backendFormErrors,
    setBackendFormErrors,
    element,
    setElement,
    loading,
    setLoading,
  };
  return (
    <DetailsActionContext.Provider value={value}>
      {children}
    </DetailsActionContext.Provider>
  );
};
